import React, { useState, useEffect } from 'react'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { apiService } from '../../constants/ApiService';
import { allRemoveItem, clearCouponData } from '../../reducetool/features/cardSlice';
import UserDashboard from '../User/UserDashboard';
import AddressModal from '../User/AddressModal';
import LoaderModal from '../../constants/LoaderModal';
import { resetToken } from '../../reducetool/features/authSlice';
import { toast } from 'react-toastify';

const Checkout = ({companyDetail}) => {
    const authData = useSelector(state => state.authState);
    const { pathname } = useLocation();
    const {
        couponCode,
        couponDiscount,
        grandTotal,
        totalSavings,
        subTotal,
        shippingCharges
      } = useSelector(state => state.cardState);

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]); // Runs whenever pathname changes
  
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const initialNewAddress = {
        id: 0,
        userId: authData.user_id,
        m_form_name: '',
        m_address: '',
        m_city: '',
        m_pin_code: '',
        m_country: '',
        m_address_type: ''
    }
    const shoppingCart = useSelector(state => state.cardState);
    const [ selectedPaymentOption, setSelectedPaymentOption] = useState("cash");
    const [userMultipleAddressList, setUserMultipleAddressList] = useState([])
    const [selectedAddressOption,setSelectedAddressOption]= useState({});
    
    const [editAddressMode, setEditAddressMode] = useState(false)
    const [newAddressData, setNewAddressData] = useState(initialNewAddress);
    const [isAddingAddress, setIsAddingAddress] = useState(false);
    const [errorAddressData, setErrorAddressData] = useState({});
    const [error, setError] = useState("");

    const GetLoginSession = async () => {
        try {
    
    
          const response = await apiService.get(`api/admin/User_Detail/LoginSession`);
        
          if (response.response && response.response.data.errors) {
            console.log(response);
            //alert(response.response?.data?.errors);
            return false;
          }
    
          if (response.status === true) {
            return true;
          }
          else {
            dispatch(resetToken());
            navigate("/login");
          }
        } catch (error) {
          //console.log(error, "errorerror")
          alert('SomeThing went wrong!!');
          return false;
        }
    }

    // let GrossTotal = shoppingCart.items.reduce((total, item) => total + (item.strike_sp * item.quantity), 0);

    // let TotalSavings = shoppingCart.items.reduce((total, item) => total + ((item.strike_sp - item.sp_after_tax) * item.quantity), 0);

    // let SubTotal = GrossTotal - TotalSavings;

    // let ShippingCharges = SubTotal >= companyDetail.free_shipping_order_amount ? 0 : companyDetail.standard_shipping_charges;

    // let CouponDisc = 0;

    // let GrandTotal = SubTotal - CouponDisc + ShippingCharges;

    const onHanldeNewAddress = () => {
        setEditAddressMode(true);
        setIsAddingAddress(true);
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewAddressData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    const handleEditConfirm = () => {
        setEditAddressMode(false);
        setNewAddressData(initialNewAddress)
        setErrorAddressData({})
    };

    const validateForm = () => {
        const errors = {};

        if (!newAddressData.m_form_name) {
            errors.m_form_name = "Name is required";
        }

        if (!newAddressData.m_address) {
            errors.m_address = "Address is required";
        }

        if (!newAddressData.m_city) {
            errors.m_city = "City is required";
        }

        if (!newAddressData.m_pin_code) {
            errors.m_pin_code = "Pin code is required";
        }

        if (!newAddressData.m_country) {
            errors.m_country = "Country is required";
        }

        if (!newAddressData.m_address_type) {
            errors.m_address_type = "Address type is required";
        }

        setErrorAddressData(errors)
        return Object.keys(errors).length === 0;
    };


    const handleAddAddress = async () => {

        let validate = await validateForm()
        if (!validate) {
            return
        }

        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };
            const response = await apiService.post(`/api/admin/User_Detail/AddMultiAddress`, newAddressData, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                console.log("Add New Address");
                setNewAddressData(initialNewAddress)
                getUserMultipleAddress()
                setEditAddressMode(false)
            }
            else {
                console.log(response);
            }
        } catch (error) {
            console.log(error)
            console.log('SomeThing went wrong!!');
        }
    };

    const handlePaymentOptionChange = (e) => {
        setSelectedPaymentOption(e.target.value);
    };

    const payment = async () => {

        if (selectedPaymentOption === null) {
            alert("Please select a Payment option");
            return
        }

        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json'
                }
            };


            let params = {
                payment_mode: selectedPaymentOption,
                user_id: authData.user_id,
                amount: grandTotal
            }

            const response = await apiService.post(`/api/PaymentMaster/create`, params, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                // console.log(response.message)
                return true;
            }
            else {
                console.log(response.message);
                return false;
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }


    const deleteAddToCardData = async()=>{
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.post(`/api/AddToCartMaster/delete?userId=${authData.user_id}`, shoppingCart.items, config)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                // dispatch(allRemoveItem())
                // console.log(response.message)
                // dispatch(allRemoveItem())
                // navigate('/order')
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const checkOutOrder = async () => {

        if(userMultipleAddressList.length === 0)
        {
            
            toast.info("Please add your address to proceed further");
            setEditAddressMode(true);
            setIsAddingAddress(true);
            //navigate("/user-dashboard?option=true");
            return
        }else{
            if (Object.keys(selectedAddressOption).length === 0 ) {
                //setError("Please select an Address to proceed further")
                toast.info("Please select an Address to place the order");
                return
            }
        }

        if (selectedPaymentOption === null) {
            toast.info("Please select a Payment option");
            return
        }

        if (selectedPaymentOption === "online_payment") {
        // 💳 Razorpay Online Payment
        // const orderAmount = 10;
        const orderAmount = grandTotal;

        try {
            const razorpayOrderRes = await apiService.post("/api/PaymentMaster/create-order", {
                amount: orderAmount
            });
           
            const { orderId, amount, currency } = razorpayOrderRes;

            const options = {
                key: companyDetail.payment_gateway_api_key,
                amount,
                currency,
                name: "Valorelle",
                description: "Order Payment",
                order_id: orderId,
                handler: async function (response) {
                    // 🔐 OPTIONAL: Call backend to verify signature
                    const verifyRes = await apiService.post("/api/PaymentMaster/verify", {
                        PaymentId: response.razorpay_payment_id,
                        OrderId: response.razorpay_order_id,
                        Signature: response.razorpay_signature
                    });

                    if (verifyRes.status === true) {
                        // ✅ Create the order in your DB now
                        await placeFinalOrder("online_payment", response.razorpay_payment_id);
                    } else {
                        toast.error("Payment verification failed.");
                    }
                },
                prefill: {
                    name: selectedAddressOption.m_form_name,
                    email: authData.email,
                    contact: authData.phone
                },
                theme: {
                    color: "#a05f43"
                }
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (err) {
            console.log(err);
            toast.error("Error initializing payment.");
        }
    } else {
        // 🧾 COD flow
        await placeFinalOrder("cash", null);
    }
   };


const placeFinalOrder = async (paymentMethod, paymentId = null) => {
    setLoading(true);

    const params = {
        grand_total: grandTotal,
        order_status: 0,
        orderItemMasterKey: shoppingCart.items,
        customer_id: authData.user_id,
        order_user_name: selectedAddressOption.m_form_name,
        order_user_address: selectedAddressOption.m_address,
        order_user_pincode: selectedAddressOption.m_pin_code,
        order_user_address_type: selectedAddressOption.m_address_type,
        order_user_city: selectedAddressOption.m_city,
        order_user_country: selectedAddressOption.m_country,
        order_payment_method: paymentMethod,
        razorpay_payment_id: paymentId, // store this in DB if needed
        coupon_code: couponCode
    };

    try {
        const response = await apiService.post(`/api/OrderMaster/create`, params);
        if (response.status === true) {
            dispatch(allRemoveItem());
            await deleteAddToCardData();
            dispatch(clearCouponData());
            navigate('/order', { state: { orderData: response.orderMasterDataByID } });
        } else {
            console.log(response.message);
        }
    } catch (err) {
        console.error(err);
        toast.error("Something went wrong while placing the order.");
    }

    setLoading(false);
};


        

    const handleAddressOptionChange = (id) => {
        let findArray = userMultipleAddressList.find((data)=> data.id === id)
        setSelectedAddressOption(findArray);
    };

    const getUserMultipleAddress = async () => {
        try {

            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    'accept': 'application/json',
                    'User_id': authData.user_id
                }
            };

            const response = await apiService.get(`/api/admin/User_Detail/GetUserMultiAddress`, config)

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            if (response.status === true) {
                setUserMultipleAddressList(response.multiUserAddData);
                setSelectedAddressOption(response.multiUserAddData?.length > 0 ? response.multiUserAddData[0] : {})
            }
            else {
                // console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }


    // const  getAddToCartData = async()=>{
    //     try {
    //         let config = {
    //             headers: {
    //                 'Content-Type': 'application/json', // Important for file upload//s
    //                 'accept': 'application/json'
    //             }
    //         };

    //         const response = await apiService.get(`/api/AddToCartMaster/addToCartByUserId?userId=${authData.user_id}`, config)
    //         if (response.response && response.response.data.errors) {
    //             alert(response.response?.data?.errors)
    //         }

    //         if (response.status === true) {
    //             console.log(response)
    //             // dispatch(allRemoveItem())
    //             // alert(response.message)
    //             // dispatch(allRemoveItem())
    //             // navigate('/order')
    //         }
    //         else {
    //             alert(response.message);
    //         }
    //     } catch (error) {
    //         console.log(error)
    //         alert('SomeThing went wrong!!');
    //     }
    // }

    useEffect(()=>{
        GetLoginSession()
        if(authData.login){
            getUserMultipleAddress()
        }
        // getAddToCartData()
    },[!userMultipleAddressList])




    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0 ">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>Checkout</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                <i className="fa-solid fa-house" />
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Checkout
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}
            {/* Checkout section Start */}
            <section className="checkout-section-2 section-b-space mb-5">
                <div className="container-fluid-lg">
                    <div className="row g-sm-4 g-3">
                        <div className="col-lg-8">
                            <div className="left-sidebar-checkout">
                                <div className="checkout-detail-box">
                                    <ul>
                                        <li>
                                            <div className="checkout-icon text-center">
                                            <h4><i className='fa fa-map-marker mt-2'/></h4>
                                            </div>
                                            <div className="checkout-box">
                                                <div className="checkout-title">
                                                    <h4>Delivery Address</h4>
                                                </div>
                                                <div className="checkout-detail">
                                                    <div className="row g-4">
                                                        {userMultipleAddressList.length ? userMultipleAddressList.map((item,key ) =>{
                                                            return(
                                                             <div className="col-xxl-12 col-lg-12 col-md-6">
                                                             <div className="delivery-address-box">
                                                                 <div>
                                                                     <div className="form-check">
                                                                         <input
                                                                             className="form-check-input"
                                                                             type="radio"
                                                                             name="jack"
                                                                             id="flexRadioDefault2"
                                                                             //checked={key===0} // Check if the current key is selected
                                                                             onChange={() => handleAddressOptionChange(item.id)}

                                                                         />
                                                                     </div>
                                                                     <div className="label">
                                                                         <label>{item.m_address_type}</label>
                                                                     </div>
                                                                     <ul className="delivery-address-detail">
                                                                         <li>
                                                                             <h4 className="fw-500">{item.m_form_name}</h4>
                                                                         </li>
                                                                         <li>
                                                                             <p className="text-content">
                                                                                 <span className="text-title">
                                                                                     Address :
                                                                                 </span>
                                                                                 {item.m_address}
                                                                             </p>
                                                                         </li>
                                                                         <li>
                                                                             <h6 className="text-content">
                                                                                 <span className="text-title">
                                                                                     Pin Code :
                                                                                 </span>
                                                                                 {item.m_pin_code}
                                                                             </h6>
                                                                         </li>

                                                                         <li>
                                                                             <h6 className="text-content">
                                                                                 <span className="text-title">
                                                                                     City :
                                                                                 </span>
                                                                                 {item.m_city}
                                                                             </h6>
                                                                         </li>
                                                                         <li>
                                                                             <h6 className="text-content">
                                                                                 <span className="text-title">
                                                                                     Country :
                                                                                 </span>
                                                                                 {item.m_country}
                                                                             </h6>
                                                                         </li>
                                                                         
                                                                     </ul>
                                                                 </div>
                                                             </div>
                                                         </div>)
                                                        }) : 
                                                        <>
                                                        <p>To place your order you need to give your address for delivery</p>
                                                       
                                                        </>}
                                                        
                                                        <button
                                                        className="btn theme-bg-color text-white fw-bold "
                                                        onClick={() => { onHanldeNewAddress() }}
                                                        >
                                                       <i data-feather="plus" className="me-2" /> Add new address
                                                       </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                         
                                        </li>
                                        <li>
                                            <div className="checkout-icon text-center">                                              
                                            <h4><i className='fa fa-coins mt-2'/></h4>
                                            </div>
                                            <div className="checkout-box">
                                                <div className="checkout-title">
                                                    <h4>Payment Option</h4>
                                                </div>
                                                <div className="checkout-detail">
                                                    <div
                                                        className="accordion accordion-flush custom-accordion"
                                                        id="accordionFlushExample"
                                                    >
                                                        <div className="accordion-item">
                                                            <div
                                                                className="accordion-header"
                                                                id="flush-headingFour"
                                                            >
                                                                <div
                                                                    className="accordion-button collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#flush-collapseFour"
                                                                >
                                                                    <div className="custom-form-check form-check mb-0">
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="cash"
                                                                        >
                                                                            <input
                                                                                className="form-check-input mt-0"
                                                                                type="radio"
                                                                                name="flexRadioDefault"
                                                                                id="cash"
                                                                                value="cash"
                                                                                onChange={handlePaymentOptionChange}
                                                                                //defaultChecked="cash"
                                                                                //checked
                                                                            />
                                                                            Cash On Delivery
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                id="flush-collapseFour"
                                                                className="accordion-collapse collapse show"
                                                                data-bs-parent="#accordionFlushExample"
                                                            >
                                                                <div className="accordion-body">
                                                                    <p className="cod-review">
                                                                        Pay at the time of delievery through Cash/UPI
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="accordion-item">
                                                            <div
                                                                className="accordion-header"
                                                                id="flush-headingTwo"
                                                            >
                                                                <div
                                                                    className="accordion-button collapsed"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target="#flush-collapseTwo"
                                                                >
                                                                    <div className="custom-form-check form-check mb-0">
                                                                        <label
                                                                            className="form-check-label"
                                                                            htmlFor="online_payment"
                                                                        >
                                                                            <input
                                                                                className="form-check-input mt-0"
                                                                                type="radio"
                                                                                name="flexRadioDefault"
                                                                                id="online_payment"
                                                                                value="online_payment"
                                                                                onChange={handlePaymentOptionChange}
                                                                            />
                                                                            Pay Online
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div
                                                                id="flush-collapseTwo"
                                                                className="accordion-collapse collapse"
                                                                data-bs-parent="#accordionFlushExample"
                                                            >
                                                                <div className="accordion-body">
                                                                <p className="cod-review">
                                                                Complete your payment using Credit/Debit Card, Net Banking, or UPI through Razorpay. You’ll be redirected to a secure page.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        

                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="right-side-summery-box">
                                <div className="summery-box-2">
                                    {shoppingCart.items.length != 0 ?
                                        <>
                                            <div className="summery-header">
                                                <h3>Order Summary</h3>
                                            </div>
                                            <ul className="summery-contain">
                                                {shoppingCart.items.map((data, index) => (
                                                    <>
                                                        <li>
                                                            <img
                                                                src={process.env.REACT_APP_API_BASE_URL +data.img_url}
                                                                className="img-fluid  lazyloaded checkout-image"
                                                                alt=""
                                                            />
                                                            <h4>
                                                                {data.name}<span>X {data.quantity}</span>
                                                            </h4>
                                                            <h4 className="price">₹ {data.quantity * data.sp_after_tax}</h4>
                                                        </li>
                                                    </>
                                                ))}
                                            </ul>
                                            <ul className="summery-total">
                                                {/* <li>
                                                    <h4>Gross Total</h4>
                                                    <h4 className="price">₹{GrossTotal}</h4>
                                                </li> */}
                                               
                                                <li>
                                                    <h4>Subtotal</h4>
                                                    <h4 className="price">₹{subTotal}</h4>
                                                </li>
                                                <li>
                                                    <h4>Coupon Discount</h4>
                                                    <h4 className="price">-₹{couponDiscount}</h4>
                                                </li>
                                                <li>
                                                    <h4>Shipping</h4>
                                                    <h4 className="price">₹{shippingCharges}</h4>
                                                </li>
                                                <li>
                                                    <h4>Your Savings</h4>
                                                    <h4 className="price">₹{totalSavings}</h4>
                                                </li>
                                                <li className="list-total">
                                                    <h4>Grand Total (Rs)</h4>
                                                    <h4 className="price">₹{grandTotal}</h4>
                                                </li>
                                            </ul>
                                        </>
                                        :
                                        <div className="empty-cart-container">
                                            <h3>Your cart is empty</h3>
                                        </div>
                                    }
                                </div>
                                {/* <div className="checkout-offer">
                                    <div className="offer-title">
                                        <div className="offer-icon">
                                            <img
                                                src="../assets/images/inner-page/offer.svg"
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </div>
                                        <div className="offer-name">
                                            <h6>Available Offers</h6>
                                        </div>
                                    </div>
                                    <ul className="offer-detail">
                                        <li>
                                            <p>
                                                Combo: BB Royal Almond/Badam Californian, Extra Bold 100
                                                gm...
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                combo: Royal Cashew Californian, Extra Bold 100 gm + BB
                                                Royal Honey 500 gm
                                            </p>
                                        </li>
                                    </ul>
                                </div> */}
                                {
                                                loading || shoppingCart.items.length === 0 ? (
                                                    <LoaderModal show={loading} />
                                                ) : (
                                <button className="btn theme-bg-color text-white btn-md w-100 mt-4 fw-bold"
                                    onClick={() => { checkOutOrder() }}
                                >
                                    Place Order
                                </button>)
                                        }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Checkout section End */}

            {editAddressMode &&
                <AddressModal
                    handleInputChange={handleInputChange}
                    newAddressData={newAddressData}
                    handleEditConfirm={handleEditConfirm}
                    //handleUpdateAddAddress={handleUpdateAddAddress}
                    isAddingAddress={isAddingAddress}
                    handleAddAddress={handleAddAddress}
                    errorAddressData={errorAddressData}
                />}
        </>

    )
}

export default Checkout;